/**
 * Runtime configuration with fallback to build-time env vars.
 *
 * In production, _ci/entrypoint.sh generates /config.js that sets window.__CONFIG__
 * from container environment variables. In dev mode, import.meta.env is used directly.
 */

interface RuntimeConfig {
  VITE_API_BASE_URL: string;
  VITE_API_MOCK_ENABLED: string;
  VITE_API_MOCK_LATENCY_MS: string;
  VITE_API_FORCE_ALL_BACKEND: string;
  VITE_USER_LABEL_TTL_HOURS: string;
  VITE_TILE_URL: string;
  VITE_FORCE_ONLINE: string;
}

const runtimeConfig: Partial<RuntimeConfig> =
  (window as unknown as { __CONFIG__?: Partial<RuntimeConfig> }).__CONFIG__ ?? {};

function env(key: keyof RuntimeConfig): string {
  return runtimeConfig[key] ?? import.meta.env[key] ?? '';
}

export const config = {
  apiBaseUrl: env('VITE_API_BASE_URL') || '/api/v1',
  mockEnabled: env('VITE_API_MOCK_ENABLED') === 'true',
  mockLatencyMs: Number(env('VITE_API_MOCK_LATENCY_MS')) || 0,
  forceAllBackend: env('VITE_API_FORCE_ALL_BACKEND') === 'true',
  userLabelTtlHours: env('VITE_USER_LABEL_TTL_HOURS'),
  tileUrl: env('VITE_TILE_URL'),
  forceOnline: env('VITE_FORCE_ONLINE') === 'true',
} as const;
